import React, { Children, cloneElement, isValidElement, memo, useMemo } from 'react';

import Avatar, { AvatarProps } from '@material-ui/core/Avatar';
import clsx from 'clsx';

import { useStyles } from './AvatarGroup.styles';
import { AvatarGroupProps } from './AvatarGroup.types';

export const AvatarGroup: React.FC<AvatarGroupProps> = memo(({ children, max }) => {
  const styles = useStyles();

  const childrenLength = Children.count(children);

  const childrenArray = useMemo(
    () => Children.toArray(children).slice(0, max || childrenLength),
    [children, childrenLength, max],
  );

  return (
    <div className={styles.wrapper}>
      {childrenArray.map(child => {
        if (!isValidElement<AvatarProps>(child)) {
          return child;
        }

        return cloneElement(child, { className: styles.avatar });
      })}

      {max && max < childrenLength && (
        <Avatar className={clsx(styles.avatar, styles.additionalAvatars)}>+{childrenLength - max}</Avatar>
      )}
    </div>
  );
});
